__webpack_require__.p = "/apps/cookbook/js/";